<template>
  <div class="instagram-star-summary-card apple-shadcn-card">
    <div class="thumbnail-bg" :style="{ backgroundImage: `url(${thumbnailUrl})` }"></div>
    
    <div class="content-overlay">
      <div class="header-text">
        <p class="title">Your Latest Insta Hit!</p>
      </div>

      <div class="stats-panel">
        <div class="stats-row">
          <span class="stat-item">
            <svg class="stat-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 12C1 12 5 5 12 5C19 5 23 12 23 12C23 12 19 19 12 19C5 19 1 12 1 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>{{ formatNumber(submission.views) }}</span>
          </span>
          <span class="stat-item">
            <svg class="stat-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>{{ formatNumber(submission.likes) }}</span>
          </span>
          <span class="stat-item coins">
             <img src="@/assets/img/coin.svg" class="stat-icon coin-icon" />
            <span>{{ formatNumber(submission.coinsEarned) }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstagramStarSummaryCard',
  props: {
    submission: {
      type: Object,
      required: true,
    },
  },
  computed: {
    thumbnailUrl() {
      // Instagram thumbnails are harder to get directly and reliably without an API or oEmbed.
      // We'll rely on the thumbnail URL saved in the submission object from the backend.
      // If it's not there, use a placeholder.
      return this.submission.thumbnail || require('@/assets/img/instagram-placeholder.svg');
    },
  },
  methods: {
    formatNumber(num) {
      if (num === undefined || num === null) return '0';
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M';
      } else if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'K';
      }
      return num.toString();
    },
  }
};
</script>

<style scoped>
.apple-shadcn-card {
  font-family: 'Poppins', sans-serif;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  height: 100%;
  background-color: #1c1c1e; /* Dark fallback */
  transition: transform 0.2s ease-out, box-shadow 0.2s ease-out;
}

.apple-shadcn-card:hover {
  /* transform: translateY(-4px); */
  /* box-shadow: 0 10px 25px rgba(0,0,0,0.1), 0 5px 10px rgba(0,0,0,0.05); */
}

.thumbnail-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  transition: transform 0.4s cubic-bezier(0.25, 0.1, 0.25, 1);
}

.apple-shadcn-card:hover .thumbnail-bg {
  transform: scale(1.03);
}

.content-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  box-sizing: border-box;
  background: linear-gradient(to bottom, rgba(0,0,0,0.25) 0%, transparent 30%, transparent 70%, rgba(0,0,0,0.1) 100%);
}

.header-text .title {
  font-size: 1rem;
  font-weight: 600;
  color: white;
  line-height: 1.3;
  text-shadow: 0 1px 3px rgba(0,0,0,0.3);
  overflow: hidden; 
  text-overflow: ellipsis; 
  white-space: nowrap;
}

.stats-panel {
  background-color: rgba(28, 28, 30, 0.75); 
  backdrop-filter: blur(18px) saturate(180%);
  -webkit-backdrop-filter: blur(18px) saturate(180%);
  border-radius: 12px;
  padding: 10px 12px; /* Adjusted padding slightly */
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.stats-row {
  display: flex;
  justify-content: space-around;
  align-items: center;
  /* margin-bottom: 8px; Removed or reduced */
}

.stat-item {
  display: flex;
  align-items: center;
  color: #E5E5EA;
  font-size: 0.8rem;
  font-weight: 500;
}

.stat-icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  color: #8E8E93;
}

.stat-item.coins .coin-icon {
  filter: none; 
  width: 15px;
  height: 15px;
  filter: drop-shadow(0 0 3px rgba(255, 215, 0, 0.5)); /* Gold glow */
}
.stat-item.coins span {
  color: #FFD700; /* Gold color for coin text */
  /* As an alternative, Instagram Pink: color: #E1306C; */
}

/* Status badge styles removed */

</style> 